import {BrowserRouter} from 'react-router-dom';
import AppContent from "./AppContent";

function App() {
    return (
        <BrowserRouter basename={process.env.REACT_APP_BASE_PATH || ''}>
            <AppContent/>
        </BrowserRouter>
    );
}

export default App
